/**
 * Define and Export Action Types
 */

export const ADMIN_CLEAR = 'ADMIN_CLEAR'

export const ADMIN_PARTNERS_PROGRAMS_REQUEST = 'ADMIN_PARTNERS_PROGRAMS_REQUEST'
export const ADMIN_PARTNERS_PROGRAMS_RECEIVE = 'ADMIN_PARTNERS_PROGRAMS_RECEIVE'
export const ADMIN_PARTNERS_PROGRAMS_FAILURE = 'ADMIN_PARTNERS_PROGRAMS_FAILURE'
export const ADMIN_PARTNERS_PROGRAM_REQUEST = 'ADMIN_PARTNERS_PROGRAM_REQUEST'
export const ADMIN_PARTNERS_PROGRAM_RECEIVE = 'ADMIN_PARTNERS_PROGRAM_RECEIVE'
export const ADMIN_PARTNERS_PROGRAM_FAILURE = 'ADMIN_PARTNERS_PROGRAM_FAILURE'
export const ADMIN_AFFILIATE_PROGRESS_REQUEST = 'ADMIN_AFFILIATE_PROGRESS_REQUEST'
export const ADMIN_AFFILIATE_PROGRESS_RECEIVE = 'ADMIN_AFFILIATE_PROGRESS_RECEIVE'
export const ADMIN_AFFILIATE_PROGRESS_FAILURE = 'ADMIN_AFFILIATE_PROGRESS_FAILURE'
export const ADMIN_PENDING_COMMISSIONS_REQUEST = 'ADMIN_PENDING_COMMISSIONS_REQUEST'
export const ADMIN_PENDING_COMMISSIONS_RECEIVE = 'ADMIN_PENDING_COMMISSIONS_RECEIVE'
export const ADMIN_PENDING_COMMISSIONS_FAILURE = 'ADMIN_PENDING_COMMISSIONS_FAILURE'
export const ADMIN_COMMISSION_APPROVE_REQUEST = 'ADMIN_COMMISSION_APPROVE_REQUEST'
export const ADMIN_COMMISSION_APPROVE_RECEIVE = 'ADMIN_COMMISSION_APPROVE_RECEIVE'
export const ADMIN_COMMISSION_APPROVE_FAILURE = 'ADMIN_COMMISSION_APPROVE_FAILURE'
export const ADMIN_COMMISSION_DISAPPROVE_REQUEST = 'ADMIN_COMMISSION_DISAPPROVE_REQUEST'
export const ADMIN_COMMISSION_DISAPPROVE_RECEIVE = 'ADMIN_COMMISSION_DISAPPROVE_RECEIVE'
export const ADMIN_COMMISSION_DISAPPROVE_FAILURE = 'ADMIN_COMMISSION_DISAPPROVE_FAILURE'
export const ADMIN_COMMISSION_DELETE_REQUEST = 'ADMIN_COMMISSION_DELETE_REQUEST'
export const ADMIN_COMMISSION_DELETE_RECEIVE = 'ADMIN_COMMISSION_DELETE_RECEIVE'
export const ADMIN_COMMISSION_DELETE_FAILURE = 'ADMIN_COMMISSION_DELETE_FAILURE'
export const ADMIN_PAYOUTS_DUE_REQUEST = 'ADMIN_PAYOUTS_DUE_REQUEST'
export const ADMIN_PAYOUTS_DUE_RECEIVE = 'ADMIN_PAYOUTS_DUE_RECEIVE'
export const ADMIN_PAYOUTS_DUE_FAILURE = 'ADMIN_PAYOUTS_DUE_FAILURE'
export const ADMIN_PAYOUT_MARK_PAID_REQUEST = 'ADMIN_PAYOUT_MARK_PAID_REQUEST'
export const ADMIN_PAYOUT_MARK_PAID_RECEIVE = 'ADMIN_PAYOUT_MARK_PAID_RECEIVE'
export const ADMIN_PAYOUT_MARK_PAID_FAILURE = 'ADMIN_PAYOUT_MARK_PAID_FAILURE'
export const ADMIN_PAYOUT_MARK_UNPAID_REQUEST = 'ADMIN_PAYOUT_MARK_UNPAID_REQUEST'
export const ADMIN_PAYOUT_MARK_UNPAID_RECEIVE = 'ADMIN_PAYOUT_MARK_UNPAID_RECEIVE'
export const ADMIN_PAYOUT_MARK_UNPAID_FAILURE = 'ADMIN_PAYOUT_MARK_UNPAID_FAILURE'
export const ADMIN_LOAD_AFFILIATE_RESOURCE_REQUEST = 'ADMIN_LOAD_AFFILIATE_RESOURCE_REQUEST'
export const ADMIN_LOAD_AFFILIATE_RESOURCE_RECEIVE = 'ADMIN_LOAD_AFFILIATE_RESOURCE_RECEIVE'
export const ADMIN_LOAD_AFFILIATE_RESOURCE_FAILURE = 'ADMIN_LOAD_AFFILIATE_RESOURCE_FAILURE'
export const ADMIN_CREATE_INVITE_REQUEST = 'ADMIN_CREATE_INVITE_REQUEST'
export const ADMIN_CREATE_INVITE_RECEIVE = 'ADMIN_CREATE_INVITE_RECEIVE'
export const ADMIN_CREATE_INVITE_FAILURE = 'ADMIN_CREATE_INVITE_FAILURE'
export const ADMIN_SAVE_INVITE_EDIT_REQUEST = 'ADMIN_SAVE_INVITE_EDIT_REQUEST'
export const ADMIN_SAVE_INVITE_EDIT_RECEIVE = 'ADMIN_SAVE_INVITE_EDIT_RECEIVE'
export const ADMIN_SAVE_INVITE_EDIT_FAILURE = 'ADMIN_SAVE_INVITE_EDIT_FAILURE'
export const ADMIN_QUERY_INVITE_REQUEST = 'ADMIN_QUERY_INVITE_REQUEST'
export const ADMIN_QUERY_INVITE_RECEIVE = 'ADMIN_QUERY_INVITE_RECEIVE'
export const ADMIN_QUERY_INVITE_FAILURE = 'ADMIN_QUERY_INVITE_FAILURE'
export const ADMIN_DELETE_INVITE_REQUEST = 'ADMIN_DELETE_INVITE_REQUEST'
export const ADMIN_DELETE_INVITE_RECEIVE = 'ADMIN_DELETE_INVITE_RECEIVE'
export const ADMIN_DELETE_INVITE_FAILURE = 'ADMIN_DELETE_INVITE_FAILURE'
